import React from 'react'

import useSpecializations from '../../hooks/useSpecializations'
import { parseSpecializationToOptionType } from '../../utilities/textUtilities'
import Filter from './Filter'
import { FILTER_SPECIALIZATION_SLUG } from './filters.constants'

const FilterSpecialization: React.FC = () => {
  const { specializations } = useSpecializations()

  return (
    <Filter
      icon="star-empty"
      slug={FILTER_SPECIALIZATION_SLUG}
      options={parseSpecializationToOptionType(specializations)}
    />
  )
}

export default FilterSpecialization
